import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Alert } from 'reactstrap'

import * as routes from '../../constants/routes'
import * as layout from '../../constants/layout'
import { auth } from '../../firebase'
import { SignInLink } from './SignIn'
import { DivWithMargin } from '../StyledComponents/Fillers'
import { SignInFormular, InputTop, InputBottom, SignInCard, SignInCardContent, SignUpLink as Link } from '../StyledComponents/Authentication'
import { NotFoundContainer } from '../StyledComponents/NotFoundPage'

const SignUpPage = ({ history }) =>
    (
        <NotFoundContainer>
            <SignUpForm history={history} />
        </NotFoundContainer>
    )

const INITIAL_STATE = {
    username: '',
    email: '',
    passwordOne: '',
    passwordTwo: '',
    error: null,
}

const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
})

class SignUpForm extends Component {
    constructor(props) {
        super(props)

        this.state = { ...INITIAL_STATE }
    }

    onSubmit = (event) => {
        const {
            email,
            passwordOne,
        } = this.state

        const {
            history,
        } = this.props

        auth.doCreateUserWithEmailAndPassword(email, passwordOne)
            .then((authUser) => {
                this.setState(() => ({ ...INITIAL_STATE }))
                history.push(routes.INTRO_QUESTIONS)
            })
            .catch((error) => {
                this.setState(byPropKey('error', error))
            })

        event.preventDefault()
    }

    render() {
        const {
            username,
            email,
            passwordOne,
            passwordTwo,
            error,
        } = this.state

        const isInvalid =
            passwordOne !== passwordTwo ||
            passwordOne === '' ||
            email === '' ||
            username === ''

        return (
            <SignInCard>
                <SignInCardContent>
                    <SignInFormular className="text-center" onSubmit={this.onSubmit}>
                        <h1 className="h3 mb-3 font-weight-normal">Registrierung</h1>

                        <DivWithMargin top="10" bottom="10">
                            <label htmlFor="inputUsername" className="sr-only">Benutzername</label>
                            <input
                                value={username}
                                onChange={event => this.setState(byPropKey('username', event.target.value))}
                                type="text"
                                id="inputUsername"
                                className="form-control"
                                placeholder="Benutzername"
                                required
                                // autoFocus
                            />
                        </DivWithMargin>

                        <DivWithMargin top="10" bottom="10">
                            <label htmlFor="inputEmail" className="sr-only">Email Adresse</label>
                            <input
                                value={email}
                                onChange={event => this.setState(byPropKey('email', event.target.value))}
                                type="email"
                                id="inputEmail"
                                className="form-control"
                                placeholder="Email Adresse"
                                required
                            />
                        </DivWithMargin>

                        <label htmlFor="inputPasswordOne" className="sr-only">Passwort</label>
                        <InputTop
                            value={passwordOne}
                            type="password"
                            id="inputPasswordOne"
                            className="form-control"
                            placeholder="Passwort"
                            onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
                            required
                        />

                        <label htmlFor="inputPasswordTwo" className="sr-only">Passwort bestätigen</label>
                        <InputBottom
                            value={passwordTwo}
                            type="password"
                            id="inputPasswordTwo"
                            className="form-control"
                            placeholder="Passwort bestätigen"
                            onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
                            required
                        />

                        <button className="btn btn-lg btn-primary btn-block" disabled={isInvalid} type="submit">
                            Registrieren
                        </button>

                        { error && <DivWithMargin top={layout.MARGIN_TOP} bottom={layout.MARGIN_BOTTOM}><Alert color="danger">{error.message}</Alert></DivWithMargin> }

                        <DivWithMargin top="10" className="small">
                            {'Du hast bereits einen Account? '}
                            <SignInLink className="text-primary" />
                        </DivWithMargin>
                    </SignInFormular>
                </SignInCardContent>
            </SignInCard>
        )
    }
}

const SignUpLink = () => <Link to={routes.SIGN_UP}>Registrieren</Link>

export default withRouter(SignUpPage)

export {
    SignUpForm,
    SignUpLink
}



// WEBPACK FOOTER //
// ./src/components/userManagement/SignUp.js